var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.status)?_c('span',{staticClass:"badge badge-pill font-14 pl-2 pr-2 pt-1 pb-1",class:_vm.statusClass},[_vm._v("\n    "+_vm._s(_vm.status)+"\n  ")]):_vm._e(),(_vm.date)?_c('small',{staticClass:"ml-1"},[_vm._v("\n    Updated on "),_c('b',[_vm._v(_vm._s(_vm._f("shortDateDisplay")(_vm.date)))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }